// extracted by mini-css-extract-plugin
export var required = "_q1-0";